<div class="d-flex justify-content-between container margin-8">
  <div>
    <h1 class="mpup-text large">{{'mpupHeader.welcome' | mbTranslate}} {{(getUserAccount() | async)?.firstName}}!</h1>
    <h2 class="mpup-text">{{'mpupHeader.whatAreYourNeeds' | mbTranslate}}</h2>
  </div>
  <img src="assets/icons/svg/MPUP_Logo_white.svg" alt="MACS Pick Up"/>
</div>
